// import * as utils from '@/utils/utils';

import { Message } from 'antd'
import services from '../services/notice.js'
const {
  getNoticeList,
  getNoticeType,
  getAddNotice,
  getNoticeDetail,
  getDraftList,
  editNotice,
  upload,
  deleteNotice,
} = services

const namespace = 'notice'

export default {
  namespace,
  state: {
    noticeList: [],
    noticeDetail: {},
    editorContent: '',
    noticeCount: 0,
    draftList: [],
    draftCount: 0,
    toggle: false,
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
    updateToggle(state) {
      return {
        ...state,
        toggle: !state.toggle,
      }
    },
  },

  effects: {
    // ================================= 协会人员角色 start ========================================
    // 获取公告列表
    *getNoticeList({ payload, callback }, { call, put }) {
      const res = yield call(getNoticeList, { ...payload })
      if (res && res.success) {
        // Message.success('')
        yield put({
          type: 'updateState',
          payload: {
            noticeList: res.data.list,
            noticeCount: res.data.total,
          },
        })
        !!callback && callback(res)
      }
    },

    // 获取草稿公告列表
    *getDraftList({ payload, callback }, { call, put }) {
      const res = yield call(getDraftList, { ...payload })
      if (res && res.success) {
        // Message.success('')
        yield put({
          type: 'updateState',
          payload: {
            draftList: res.data.list,
            draftCount: res.data.total,
          },
        })
        !!callback && callback(res)
      }
    },

    // 获取公告详情
    *getNoticeDetail({ payload, callback }, { call, put }) {
      const res = yield call(getNoticeDetail, { ...payload })
      if (res && res.success) {
        // Message.success('')
        yield put({
          type: 'updateState',
          payload: {
            noticeDetail: res.data,
            editorContent: res.data.content,
          },
        })
        !!callback && callback(res)
      }
    },

    // 新增公告
    *getAddNotice({ payload, callback }, { call, put }) {
      const res = yield call(getAddNotice, { ...payload })
      if (res && res.success) {
        Message.success('新增成功')
        yield put({
          type: 'updateToggle',
        })
        !!callback && callback(res)
      } else {
        Message.error(res.msg)
      }
    },

    // 编辑公告
    *editNotice({ payload, callback }, { call, put }) {
      const res = yield call(editNotice, { ...payload })
      if (res && res.success) {
        Message.success('编辑成功')
        !!callback && callback(res)
      } else {
        Message.error(res.msg)
      }
    },

    *clearnoticeDetailFromStore({ payload, callback }, { call, put }) {
      yield put({
        type: 'updateState',
        payload: {
          noticeDetail: [],
          editorContent: [],
        },
      })
      !!callback && callback()
    },

    // 上传
    *upload({ payload, callback }, { call, put }) {
      const res = yield call(upload, { ...payload })
      if (res && res.success) {
        !!callback && callback(res)
      } else {
        Message.error(res.msg)
      }
    },

    // 存储富文本内容
    *setEditorHtml({ payload, callback }, { call, put }) {
      yield put({
        type: 'updateState',
        payload: {
          editorContent: payload.editorContent,
        },
      })
    },

    // 删除公告信息
    *deleteNotice({ payload, callback }, { call, put }) {
      const res = yield call(deleteNotice, { ...payload })
      if (res && res.success) {
        Message.success('删除成功')
        yield put({
          type: 'updateToggle',
        })
        !!callback && callback(res)
      } else {
        Message.error('删除失败：' + res.msg)
      }
    },
  },
  // 订阅事件
  subscriptions: {},
}
